import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import { useDashboardSetting } from './useDashboardSetting'

// A profile dropdown item: it renders outside the page's DashboardProvider, so it reads and writes the row itself.
export const DashboardLockToggle = () => {
  const { setting, loading, save } = useDashboardSetting()

  return (
    <Dropdown.Item disabled={loading} onClick={() => save({ isLocked: !setting.isLocked })}>
      <HorizontalStack gap={1}>
        <Icon name={setting.isLocked ? 'unlock' : 'lock'} />
        <span>{setting.isLocked ? 'Unlock' : 'Lock'} dashboard</span>
      </HorizontalStack>
    </Dropdown.Item>
  )
}
